import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {LOCALE_ID, NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from "ngx-toastr";
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { FixedPluginModule} from './shared/fixedplugin/fixedplugin.module';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ModalComponent } from './pages/modal/modal.component';
import es from '@angular/common/locales/es';
import { registerLocaleData} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotificationsComponent} from './pages/notifications/notifications.component';
import { AuthImagePipe } from './auth-image.pipe';
import {NgxSpinnerModule} from 'ngx-spinner';
import {EditVehicleComponent} from './pages/edit-vehicle/edit-vehicle.component';
import {DpDatePickerModule} from 'ng2-date-picker';
import {NgbDatepickerModule, NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {EditDocumentUserComponent} from './pages/edit-document-user/edit-document-user.component';
import {EditDocumentVehicleComponent} from './pages/edit-document-vehicle/edit-document-vehicle.component';
import {EditDocumentLicenseComponent} from './pages/edit-document-license/edit-document-license.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import { TrustHtmlPipe } from './trust-html.pipe';
registerLocaleData(es);

@NgModule({
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        ModalComponent,
        EditVehicleComponent,
        EditDocumentUserComponent,
        EditDocumentVehicleComponent,
        EditDocumentLicenseComponent,
        NotificationsComponent,
        AuthImagePipe,
        //TrustHtmlPipe
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        DpDatePickerModule,
        NgImageFullscreenViewModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, {
            useHash: true
        }),
        SidebarModule,
        NavbarModule,
        ToastrModule.forRoot(),
        FooterModule,
        FixedPluginModule,
        NgxSpinnerModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        AngularEditorModule
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'es-*'},
        NotificationsComponent
    ],
    entryComponents: [
        ModalComponent,
        EditVehicleComponent,
        EditDocumentUserComponent,
        EditDocumentVehicleComponent,
        EditDocumentLicenseComponent
    ],
    exports: [
        AuthImagePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
